import { AxiosResponse } from 'axios';

import { FormFieldOption } from '../../pages/authView/components/registration/interfaces';
import { handleApiError, phpApi } from '../default';

export const fetchRegistrationFieldOptions: (
  dataType: string,
  division: string
) => Promise<FormFieldOption[]> = async (
  dataType: string,
  division: string
): Promise<FormFieldOption[]> => {
  const url: string = `/api/static/${dataType}/${division}`;

  return phpApi
    .get<FormFieldOption[]>(url)
    .then((response: AxiosResponse<FormFieldOption[]>): FormFieldOption[] => response.data)
    .catch(handleApiError);
};
